import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';

import * as types from './mutation-types';

export function fetchSubscriptionsVideoCourses({ dispatch }, lectureType) {
  return http.get(`${MINERVA_API_URL}/users/me/subscriptions/video-courses`)
    .then(res => (
      dispatch('setSubscriptionsCourses', {
        subscriptionsCourses: res.data,
        lectureType,
      })
    ));
}

export function setSubscriptionsCourses({ commit }, { subscriptionsCourses, lectureType }) {
  commit(types.SET_SUBSCRIPTIONS_COURSES, { subscriptionsCourses, lectureType });

  return Promise.resolve(subscriptionsCourses);
}

export function resetSubscriptionsCourses({ commit }) {
  commit(types.RESET_SUBSCRIPTIONS_COURSES);
}

export function resetSubscriptionsCoursesPosition({ commit }) {
  commit(types.RESET_SUBSCRIPTIONS_COURSES_POSITION);
}

export function fetchVideoCourseIsSubscribed({ dispatch }, { courseId, userId }) {
  return http.get(`${MINERVA_API_URL}/video-courses/${courseId}/subscribed-users/${userId}`)
    .then(() => (true))
    .catch((err) => {
      if (err.response.status === 404) {
        return false;
      }

      return Promise.reject(err);
    });
}

export function fetchCardCourseIsSubscribed({ dispatch }, { courseId, userId }) {
  return http.get(`${MINERVA_API_URL}/card-courses/${courseId}/subscribed-users/${userId}`)
    .then(() => (true))
    .catch((err) => {
      if (err.response.status === 404) {
        return false;
      }

      return Promise.reject(err);
    });
}

export function fetchSubscriptionsCardCourses({ dispatch }, lectureType) {
  return http.get(`${MINERVA_API_URL}/users/me/subscriptions/card-courses`)
    .then(res => (
      dispatch('setSubscriptionsCourses', {
        subscriptionsCourses: res.data,
        lectureType,
      })
    ));
}

export function fetchCardCourse({ dispatch }, courseId) {
  return http.get(`${MINERVA_API_URL}/card-courses/${courseId}`)
    .then(res => res.data);
}

export function setCardCourse({ commit }, videoCourse) {
  commit(types.SET_CARD_COURSE, videoCourse);

  return Promise.resolve(videoCourse);
}

export function fetchVideoCourse({ dispatch }, courseId) {
  return http.get(`${MINERVA_API_URL}/video-courses/${courseId}`)
    .then(res => res.data);
}

export function setVideoCourse({ commit }, videoCourse) {
  commit(types.SET_VIDEO_COURSE, videoCourse);

  return Promise.resolve(videoCourse);
}

export function fetchVideoCoursesLectures({ dispatch }, filters) {
  return http.get(`${MINERVA_API_URL}/video-lectures`, { params: filters })
    .then(res => res.data);
}


export function fetchCardCoursesLectures({ dispatch }, filters) {
  return http.get(`${MINERVA_API_URL}/card-lectures`, { params: filters })
    .then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/app/course/store/actions.js